import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Resources-index-1992f2b8ae0705384-1'),
    routerUrl: '/Resources',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Resources')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Resources-index-1992f2b8ae0705384-2'),
        routerUrl: '/ResourcesForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./ResourcesForm')),
      },
      //$MORE$
    ],
  },
];
